import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "utils/cropImage"; // Function to crop image
import { Button } from "components/Button";
import EssFullWidthModal from "components/modelpopup/baseModal";
import Image from "components/Image";
import useUploadHook from "components/uploadHook";
import { changeEmployeeDetail } from "api/services/employee";


const ChangePictureModal = ({ show, handleClose, currentImage, onSave, id, changeImage }) => {
  const [selectedImage, setSelectedImage] = useState(null); // Original image
  const [croppedImage, setCroppedImage] = useState(null); // Cropped preview
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [loading, setLoading] = useState(false);

  const { uploadLoading, handleFile } = useUploadHook();

  // Handle Image Selection
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        setSelectedImage(reader.result); // Show image in cropper
      };
    }
  };

  // Save cropped area
  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  // Generate Cropped Image
  const cropImage = async () => {
    try {
      const croppedBlob = await getCroppedImg(selectedImage, croppedAreaPixels);
      setCroppedImage(URL.createObjectURL(croppedBlob)); // Show preview
      return croppedBlob;
    } catch (error) {
      console.error("Error cropping image:", error);
    }
  };

  // Handle Upload
  const handleSubmit = async () => {
    setLoading(true);
    const croppedBlob = await cropImage();
    console.log(croppedBlob, "KKK")
    if (!croppedBlob) return;

    const file = new File([croppedBlob], "profile.jpg", { type: "image/jpeg" });
    console.log(file, "KKK")
    let ob = {
      target:{
        files:[file]
      }
    }

    const urls = await handleFile(ob); // Upload to S3
    console.log(urls, "KKK")

    await changeEmployeeDetail(id,{profile_image: urls})

    setLoading(false);
    if (urls) {
      changeImage(urls); // Update profile image
      handleCloseModal();
    }
  };

  const handleCloseModal = () => {
    setSelectedImage(null); // Clear selected image
    setCroppedImage(null);  // Clear cropped image
    setCrop({ x: 0, y: 0 }); // Reset crop position
    setZoom(1);  // Reset zoom level
    setCroppedAreaPixels(null); // Reset crop area
    setLoading(false); // Reset loading state
    handleClose(); // Call the parent function to close modal
  };

  return (
    <>
      <div role="dialog">
        <EssFullWidthModal
          title="Change Profile Picture"
          open={show}
          width="40%"
          footer={[]}     
          onCancel={handleCloseModal}


          mask={false}
          // style={{ top: 100 }}
         
            className="full-width-modal"



        >
          <div className="modal-content">
            <div className="modal-body">
              <label htmlFor="profile-pic-upload" className="d-block">
                <div className="mx-auto rounded-circle overflow-hidden"
                  style={{ width: "150px", height: "150px", border: "2px dashed #ccc", cursor: "pointer" }}>
                  <Image src={croppedImage || selectedImage || currentImage} alt="Profile" className="w-100 h-100" style={{ objectFit: "cover" }} />
                </div>
              </label>
              <input
                type="file"
                id="profile-pic-upload"
                className="d-none"
                accept="image/*"
                onChange={handleImageChange}
              />

              {/* Cropper UI */}
              {selectedImage && (
                <div className="mt-3 shadow" style={{ position: "relative", width: "100%", height: 300 }}>
                  <Cropper
                    image={selectedImage}
                    crop={crop}
                    zoom={zoom}
                    aspect={1}
                    onCropChange={setCrop}
                    onZoomChange={setZoom}
                    onCropComplete={onCropComplete}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="submit-section">
            <Button
              disabled={!selectedImage || uploadLoading || loading}
              className="btn btn-primary"
              onClick={handleSubmit}
              label="Submit"
              loading={uploadLoading || loading}
            />
          </div>
        </EssFullWidthModal>
      </div>
    </>
  );
};

export default ChangePictureModal;